import { css } from '../../styled-components';

export const jsonStyles = css`
    .redoc-json code > .collapser {
        display: none;
        pointer-events: none;
    }

    font-family: ${(props) => props.theme.typography.code.fontFamily};
    font-size: ${(props) => props.theme.typography.code.fontSize};

    white-space: ${({ theme }) => (theme.typography.code.wrap ? 'pre-wrap' : 'pre')};
    contain: content;
    overflow-x: auto;

    .callback-function {
        color: gray;
    }

    .collapser:after {
        content: '-';
        cursor: pointer;
    }

    .collapsed > .collapser:after {
        content: '+';
        cursor: pointer;
    }

    .ellipsis:after {
        content: ' … ';
    }

    .collapsible {
        margin-left: 2em;
    }

    .hoverable {
        padding-top: 1px;
        padding-bottom: 1px;
        padding-left: 2px;
        padding-right: 2px;
        border-radius: 2px;
    }

    .hovered {
        background-color: rgba(235, 238, 249, 1);
    }

    .collapser {
        background-color: transparent;
        border: 0;
        color: #fff;
        font-family: ${(props) => props.theme.typography.code.fontFamily};
        font-size: ${(props) => props.theme.typography.code.fontSize};
        padding-right: 6px;
        padding-left: 6px;
        padding-top: 0;
        padding-bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 15px;
        height: 15px;
        position: absolute;
        top: 4px;
        left: -1.5em;
        cursor: default;
        user-select: none;
        -webkit-user-select: none;
        padding: 2px;
        &:focus {
            outline-color: #fff;
            outline-style: dotted;
            outline-width: 1px;
        }
    }

    ul {
        list-style-type: none;
        padding: 0px;
        margin: 0px 0px 0px 26px;
    }

    li {
        position: relative;
        display: block;
    }

    .hoverable {
        display: inline-block;
    }

    .selected {
        outline-style: solid;
        outline-width: 1px;
        outline-style: dotted;
    }

    .collapsed > .collapsible {
        display: none;
    }

    .ellipsis {
        display: none;
    }

    .collapsed > .ellipsis {
        display: inherit;
    }
`;
